import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Star } from 'lucide-react';
import { testimonials } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (dir: 1 | -1) => setIndex(i => (i + dir + testimonials.length) % testimonials.length);
  return <section className="w-full bg-white py-24 lg:py-32" data-id="element-369" data-mp="3205zwrjs17l5">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-370" data-mp="31yl6x6d41wpe">
        <Reveal data-id="element-371" data-mp="2x007381rtf1h">
          <SectionHeading label="Testimonials" align="center" title="Trusted by homeowners" data-id="element-372" data-mp="2x1l02t8fspx8" />
        </Reveal>

        <Reveal delay={0.1} data-id="element-373" data-mp="2s39skp5m6ri6">
          <div className="relative mx-auto mt-16 max-w-4xl border-t border-mist-200 pt-14 text-center" data-id="element-374" data-mp="2s42wlid6v2wm">
            <span className="pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 font-heading text-[7rem] font-extrabold leading-none text-mist-100 sm:text-[10rem]" aria-hidden="true" data-id="element-375" data-mp="qac2h1382d0x">
              “
            </span>

            <AnimatePresence mode="wait" data-id="element-376" data-mp="m6cdzoyx68xy">
              <motion.blockquote key={index} initial={{
              opacity: 0,
              y: 16
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -16
            }} transition={{
              duration: 0.4,
              ease: 'easeOut'
            }} className="relative" data-id="element-377" data-mp="78aatfvsvph8">
                <p className="font-heading text-2xl font-semibold leading-snug tracking-tight text-navy sm:text-3xl lg:text-4xl" data-id="element-378" data-mp="14uhe8mgdbbs0">
                  {active.quote}
                </p>
                <footer className="mt-10" data-id="element-379" data-mp="v57kl25vll1s">
                  <div className="flex items-center justify-center gap-1" aria-label="Rated 5 out of 5" data-id="element-380" data-mp="v3wkpdfjwxfy">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <Star key={i} className="h-4 w-4 fill-brand-500 text-brand-500" aria-hidden="true" data-id="element-381" data-mp="1nn23zv0rt0rl" data-mpi={i} />)}
                  </div>
                  <p className="mt-5 font-heading text-sm font-bold uppercase tracking-[0.18em] text-navy" data-id="element-382" data-mp="1xfmul8274vu9">
                    {active.name}
                  </p>
                  <p className="mt-2 text-sm text-mist-600" data-id="element-383" data-mp="1ofrdkmlym6mb">{active.project}</p>
                </footer>
              </motion.blockquote>
            </AnimatePresence>

            <div className="mt-12 flex items-center justify-center gap-4" data-id="element-384" data-mp="1ejem7vdw04uq">
              <button type="button" onClick={() => go(-1)} aria-label="Previous testimonial" className="inline-flex h-12 w-12 items-center justify-center border border-mist-200 text-navy transition hover:border-brand-500 hover:bg-brand-500 hover:text-white" data-id="element-385" data-mp="19ser8vobvwuv">
                <ArrowLeft className="h-4 w-4" data-id="element-386" data-mp="vrlt80ytijn0" />
              </button>
              <div className="flex items-center gap-2" role="tablist" aria-label="Select testimonial" data-id="element-387" data-mp="qttykz6sgjf4">
                {testimonials.map((t, i) => <button key={t.project} type="button" role="tab" aria-selected={i === index} aria-label={`Testimonial ${i + 1}`} onClick={() => setIndex(i)} className={['h-[3px] transition-all duration-300', i === index ? 'w-10 bg-brand-500' : 'w-5 bg-mist-200 hover:bg-mist-400'].join(' ')} data-id="element-388" data-mp="32gntyv5lbl4x" data-mpi={i} />)}
              </div>
              <button type="button" onClick={() => go(1)} aria-label="Next testimonial" className="inline-flex h-12 w-12 items-center justify-center border border-mist-200 text-navy transition hover:border-brand-500 hover:bg-brand-500 hover:text-white" data-id="element-389" data-mp="2squhlrxmj1zm">
                <ArrowRight className="h-4 w-4" data-id="element-390" data-mp="24zyv9abxsyzr" />
              </button>
            </div>

            <p className="mt-10 text-[11px] uppercase tracking-[0.18em] text-mist-400" data-id="element-391" data-mp="1lxomlfzwj6dj">
              Placeholder testimonials — replace with verified customer reviews before launch
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}